import { Routes } from '@angular/router';
import { CapicheAuthShellComponent } from './lib/capiche-auth-shell/capiche-auth-shell.component';
import { LoginComponent } from './lib/pages/login/login.component';
import { RegisterComponent } from './lib/pages/register/register.component';
import { ResetPasswordComponent } from './lib/pages/reset-password/reset-password.component';
import { redirectIfAuthenticatedGuard } from './lib/guards/redirect-if-authenticated.guard';

export const authRoutes: Routes = [
  {
    path: '',
    component: CapicheAuthShellComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent, canActivate: [redirectIfAuthenticatedGuard] },
      { path: 'register', component: RegisterComponent, canActivate: [redirectIfAuthenticatedGuard] },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: '**', redirectTo: 'login' },
    ],
  },
];
